export default {"src":"/_next/static/media/logo-bufdir.a5c14103.svg","height":1687,"width":1653,"blurWidth":0,"blurHeight":0};